import React from "react";

export const ReloadIconBlue = (props) => {
  return (
    <>
      <svg
        onClick={props?.onClick}
        className={props?.className}
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5625 0C5.58096 0 2.32971 3.17357 2.14271 7.14286H0L3.54167 11.875L7.08333 7.14286H4.97604C5.15808 4.74929 7.14354 2.85714 9.5625 2.85714C12.1012 2.85714 14.1667 4.94 14.1667 7.5C14.1667 10.06 12.1012 12.1429 9.5625 12.1429C8.24288 12.1429 7.05358 11.5764 6.2135 10.6764L4.49437 12.9736C5.82392 14.2264 7.60325 15 9.5625 15C13.6637 15 17 11.6357 17 7.5C17 3.36429 13.6637 0 9.5625 0Z"
          fill="#3A94FF"
          style={{
            fill: "#3A94FF",
            fill: "color(display-p3 0.2294 0.5816 0.9983)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
